import React from 'react';
import useLogoProportions from '@age-gateway/hooks/useLogoProportions';
import NoAccessIcon from './NoAccessIcon';
import styles from './noAccess.module.scss';
import type { NoAccessProps } from './types';
import marketLinks from '../../config/marketLinks.json';
import { getProjectInfo } from 'global-utils/get-attributes';

const NoAccess = ({ logoUrl, brandName, translations }: NoAccessProps) => {
  const { isLogoHorizontal } = useLogoProportions(logoUrl);
  const { prjMarket } = getProjectInfo();
  const { markets } = marketLinks;
  const location = prjMarket?.toUpperCase();
  const currentMarketInfo = markets.find(
    (market) => market.countryCode === location
  );

  const responsibleLink =
    currentMarketInfo?.responsibleLink || 'http://www.responsibledrinking.org';

  const noAccessMessage = {
    __html: translations?.restrictedAccess
      ?.toString()
      .replace('{{responsibleDrinkingLink}}', responsibleLink)
      .replace('<break></break>', '<br />')
  };

  return (
    <div className={styles.root}>
      <main className={styles.content}>
        {logoUrl && (
          <div
            className={styles.logo}
            // provides a height for the logo container if the logo is not horizontal
            style={isLogoHorizontal ? null : { height: '120px' }}
          >
            <img
              src={logoUrl}
              alt={`${brandName} logo`}
              width="143"
              height="68"
              style={
                isLogoHorizontal
                  ? { width: '100%', height: 'auto' }
                  : { height: '100%', width: 'auto' }
              }
            />
          </div>
        )}
        <div className={styles.noAccess}>
          <NoAccessIcon />
        </div>
        <p
          className={styles.caption}
          dangerouslySetInnerHTML={noAccessMessage}
        />
      </main>
    </div>
  );
};

export default NoAccess;
